import http from '../../../utils/tools/http';

import {
  QUES_STORE_FETCH_SUBMIT_PRA_BEGIN,
  QUES_STORE_FETCH_SUBMIT_PRA_SUCCESS,
  QUES_STORE_FETCH_SUBMIT_PRA_FAILURE,
  QUES_STORE_FETCH_SUBMIT_PRA_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchSubmitPra(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: QUES_STORE_FETCH_SUBMIT_PRA_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = http.post({ url: "/datastore/Chapter/SubmitPractice", params: args });
      doRequest.then(
        (res) => {
          dispatch({
            type: QUES_STORE_FETCH_SUBMIT_PRA_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: QUES_STORE_FETCH_SUBMIT_PRA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchSubmitPraError() {
  return {
    type: QUES_STORE_FETCH_SUBMIT_PRA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case QUES_STORE_FETCH_SUBMIT_PRA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchSubmitPraPending: true,
        fetchSubmitPraError: null,
      };

    case QUES_STORE_FETCH_SUBMIT_PRA_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchSubmitPraPending: false,
        fetchSubmitPraSuccess: action.data.Data,
      };

    case QUES_STORE_FETCH_SUBMIT_PRA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchSubmitPraPending: false,
        fetchSubmitPraError: action.data.error,
      };

    case QUES_STORE_FETCH_SUBMIT_PRA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchSubmitPraError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/ques-store/redux/fetchSubmitPra.js